import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getDairyCowSales } from "services";

import { GET_DAIRY_COWS_SOLD } from "consts";

export const useGetFootprintingDairyCowSalesByPrimaryDataId = (primaryDataId: string) => {
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [GET_DAIRY_COWS_SOLD, primaryDataId],
      queryFn: () => getDairyCowSales(primaryDataId),
      enabled: !!primaryDataId,
      gcTime: 60000,
    },
    queryClient
  );
};
